// libraries
import type { StateTree } from '@makemydeal/dr-dash-types';

export const getReportIssueIsSubmitting = (state: StateTree): boolean => {
    return state.reportIssue?.isSubmitting ?? false;
};

export const getReportIssueIsSuccess = (state: StateTree): boolean => {
    return state.reportIssue?.isSuccess ?? false;
};

export const getReportIssueIsFailure = (state: StateTree): boolean => {
    return state.reportIssue?.isFailure ?? false;
};
